export default "__VITE_ASSET__DGMlmtEs__"